import { render, staticRenderFns } from "./GroupsTable.vue?vue&type=template&id=9ac2e6e4&scoped=true&lang=pug&"
import script from "./GroupsTable.vue?vue&type=script&lang=js&"
export * from "./GroupsTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTable.vue?vue&type=style&index=0&id=9ac2e6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac2e6e4",
  null
  
)

export default component.exports